import React, { Component } from 'react';
import { connect } from 'react-redux';
import FormModal from '../../../../shared/modal/FormModal';
import RouteTitle from '../../../../shared/route-title/RouteTitle';
import numeral from 'numeral';
import CheckBox from '../../../../shared/checkbox/CheckBox';
import {
  getOpenItemsByTaskId,
  getSelectedOpenItemId,
} from '../../../../../selectors/admin/work-orders/details/details';
import { getCurrentWorkOrder } from '../../../../../selectors/admin/work-orders/work-orders';
import {
  setSelectedOpenItem,
  submitEditOpenRequestRequest,
} from '../../../../../actions/admin/work-orders/details/details';
import {
  getEditOpenItem,
  getMembers,
  getEditForm,
} from 'selectors/admin/work-orders/details/open-items';
import './EditOpenItemModal.css';
import {
  changeAssigneeRequest,
  setEditOpenItem,
  updateEditFormValue,
} from 'actions/admin/work-orders/details/open-items';
import TextArea from '../../../../shared/input/TextArea';
import Button from '../../../../shared/button/Button';
import PropTypes from 'prop-types';
import Dropdown from '../../../../shared/dropdown/Dropdown';
import DatetimePicker from 'components/shared/datetime-picker/DatetimePicker';
import Date from 'components/shared/text/Date';

class EditOpenItemModal extends Component {
  constructor(props) {
    super(props);

    let openItem = props.openItemsByTaskId[props.taskId].find(
      (openItem) => openItem.id === props.selectedOpenItemId
    );

    props.dispatch(updateEditFormValue('userId', openItem.user.id));
    props.dispatch(updateEditFormValue('description', openItem.description));
    props.dispatch(updateEditFormValue('dueDate', openItem.due_date));
    props.dispatch(updateEditFormValue('resolved', openItem.resolved));
    props.dispatch(
      updateEditFormValue('resolvedNote', openItem.resolved_note || '')
    );

    this.state = { openItem: openItem };
  }

  // This modal is called from DetailsTasks and DetailsOpenItems, for the latter no current task is available.
  static propTypes = {
    taskId: PropTypes.number,
    taskNumber: PropTypes.number,
  };

  handleClose = () => {
    this.props.dispatch(setSelectedOpenItem(null));
  };

  handleSubmit = () => {
    this.props.dispatch(
      submitEditOpenRequestRequest(
        this.props.taskId,
        this.props.selectedOpenItemId,
        this.props.editForm
      )
    );
  };

  handleEditOpenItemClick = () => {
    if (this.props.members.length === 0) {
      this.props
        .dispatch(changeAssigneeRequest(this.props.taskId))
        .then((response) => {
          if (response.ok) {
            this.props.dispatch(setEditOpenItem(true));
          }
        });
    } else {
      this.props.dispatch(setEditOpenItem(true));
    }
  };

  handleAttributeChange = (attribute, value) => {
    this.props.dispatch(updateEditFormValue(attribute, value));
  };

  render() {
    const openItem = this.state.openItem;
    return (
      <FormModal
        className="edit-open-item-modal"
        show={this.props.selectedOpenItemId !== null}
        subTitle={
          <RouteTitle
            titles={[
              this.props.currentWorkOrder.client.company_name.toUpperCase(),
              `TASK #${this.props.currentWorkOrder.number}-${numeral(
                this.props.taskNumber
              ).format('00')}-${openItem.letter}`,
            ]}
          />
        }
        title={`Open Item${openItem.resolved ? ' - Resolved' : ''}`}
        onClose={this.handleClose}
      >
        {!this.props.editOpenItem ? (
          <div className="h2">
            {`${openItem.letter}${openItem.critical ? ' (Critical)' : ''}: ${
              openItem.description
            }`}
          </div>
        ) : (
          <TextArea
            className="h2"
            placeholder="Open Item Description..."
            value={this.props.editForm.description}
            onChange={this.handleAttributeChange.bind(this, 'description')}
          />
        )}

        <div className="table-container">
          <table>
            <tbody>
              <tr>
                <td>Assigned To</td>
                {!this.props.editOpenItem ? (
                  <td className="read-only-user-name">{`${openItem.user.first_name} ${openItem.user.last_name}`}</td>
                ) : (
                  <td>
                    <Dropdown
                      className="member-dropdown"
                      options={this.props.members
                        .filter((member) => member.user.status === 'active')
                        .map((member) => {
                          return {
                            value: member.user.id,
                            label: `${member.user.first_name} ${member.user.last_name}`,
                          };
                        })}
                      placeholder="Select New Assignee"
                      value={this.props.editForm.userId}
                      onChange={(newOption) =>
                        this.handleAttributeChange('userId', newOption.value)
                      }
                    />
                  </td>
                )}
              </tr>
              <tr>
                <td>Due Date</td>
                {!this.props.editOpenItem ? (
                  <td className="read-only-due-date">
                    <Date value={openItem.due_date} format="M/D/YYYY" />
                  </td>
                ) : (
                  <td>
                    <DatetimePicker
                      readOnly={!this.props.editOpenItem}
                      placeholder="Due Date"
                      value={this.props.editForm.dueDate}
                      onChange={this.handleAttributeChange.bind(
                        this,
                        'dueDate'
                      )}
                    />
                  </td>
                )}
              </tr>
            </tbody>
          </table>
        </div>

        {!openItem.resolved && (
          <div className="mark-resolved-container">
            <CheckBox
              readOnly={!this.props.editOpenItem}
              checked={this.props.editForm.resolved}
              shape="round"
              size="medium"
              onChange={() =>
                this.handleAttributeChange(
                  'resolved',
                  !this.props.editForm.resolved
                )
              }
            />
            <span>Mark as Resolved</span>
          </div>
        )}

        {!openItem.resolved ? (
          <div>
            <TextArea
              className="note-textarea"
              disabled={!this.props.editOpenItem}
              placeholder="Note"
              value={this.props.editForm.resolvedNote}
              onChange={this.handleAttributeChange.bind(this, 'resolvedNote')}
            />
          </div>
        ) : (
          openItem.resolved_note !== null &&
          openItem.resolved_note !== '' && (
            <div className="table-container">
              <table>
                <tbody>
                  <tr>
                    <td>Note</td>
                    <td className="resolved-note">{openItem.resolved_note}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          )
        )}

        {!openItem.resolved && (
          <div className="button-container">
            {!openItem.resolved && !this.props.editOpenItem ? (
              <Button
                className="button-orange"
                label="Edit"
                onClick={this.handleEditOpenItemClick}
              />
            ) : (
              <Button
                className="button-orange"
                label="Save"
                onClick={this.handleSubmit}
              />
            )}
          </div>
        )}
      </FormModal>
    );
  }
}

export default connect((state) => {
  return {
    editOpenItem: getEditOpenItem(state),
    currentWorkOrder: getCurrentWorkOrder(state),
    members: getMembers(state),
    openItemsByTaskId: getOpenItemsByTaskId(state),
    editForm: getEditForm(state),
    selectedOpenItemId: getSelectedOpenItemId(state),
  };
})(EditOpenItemModal);



// WEBPACK FOOTER //
// ./src/components/admin/work-orders/details/open-items/EditOpenItemModal.js